import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormControlComponent } from '../form-control/form-control.component';

@Component({
	selector: 'ws-input-date',
	templateUrl: './input-date.component.html',
	styleUrls: ['./input-date.component.scss'],
})
export class InputDateComponent extends FormControlComponent implements OnInit, OnChanges {
	@Input() maxDate: any;
	@Input() asRange = false;
	@Input() asMatFormField = false;

	constructor() {
		super();
	}

	public emitRangeChange() {
		if (!!this.result.from && !!this.result.to) {
			// Convert to Date object if it isn't already (could be string or Moment)
			const toDate = new Date(this.result.to);

			// Set 'to' date to end of day (23:59:59.999)
			toDate.setHours(23, 59, 59, 999);

			this.result.to = toDate;

			this.resultChange.emit(this.result);
		}
	}

	ngOnInit(): void {
		super.ngOnInit();
	}
}
